export const GAevent = (name, payload) => {
  if (!process.env.REACT_APP_GOOGLE_ANALYTICS_ID || !window?.gtag) {
    return
  }

  window.gtag('event', name, payload)
}
